import Grid from "@mui/material/Grid2";
import { DotLegalDialog } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { PredefinedRiskAreaViewModel } from "../riskAreas/RiskAreas.types";
import { usePredefinedRiskAreas } from "./PredefinedRiskAreas.hooks";
import { customRiskAreaImage, getPredefinedRiskAreaImage } from "./predefinedRiskAreaImage";
import RiskAreaTemplateCard from "./RiskAreaTemplateCard";
import DialogHeaderWithInformation from "@common/components/dialogHeaderWithInformation/DialogHeaderWithInformation";

export interface SelectRiskAreaTemplateDialogProps {
    onSelectPredefined: (predefinedRiskArea: PredefinedRiskAreaViewModel) => void;
    onSelectCustom: () => void;
    onCloseDialog: () => void;
}

function SelectRiskAreaTemplateDialog(props: SelectRiskAreaTemplateDialogProps) {
    const { translateString } = useTranslation();
    const { isLoading, predefinedRiskAreas } = usePredefinedRiskAreas();

    return (
        <DotLegalDialog
            open
            header={<DialogHeaderWithInformation header={translateString("createRiskArea")} information={translateString("riskAreaNameTooltip")} />}
            buttonOkText=""
            hideOkButton
            size="md"
            disableTransition
            isLoading={isLoading}
            onOkClick={() => {}}
            onDialogClose={props.onCloseDialog}
        >
            <Grid container spacing={2} sx={{ pb: 3 }}>
                {predefinedRiskAreas.map((predefinedRiskArea) => (
                    <Grid key={predefinedRiskArea.key} size={{ xs: 12, sm: 4 }}>
                        <RiskAreaTemplateCard
                            name={predefinedRiskArea.name}
                            image={getPredefinedRiskAreaImage(predefinedRiskArea.key)}
                            isAdded={predefinedRiskArea.isAdded}
                            onClick={() => props.onSelectPredefined(predefinedRiskArea)}
                        />
                    </Grid>
                ))}
                <Grid size={{ xs: 12, sm: 4 }}>
                    <RiskAreaTemplateCard name={translateString("riskAreaCustom")} image={customRiskAreaImage} isCustom onClick={props.onSelectCustom} />
                </Grid>
            </Grid>
        </DotLegalDialog>
    );
}

export default SelectRiskAreaTemplateDialog;
